import React from 'react';
import { FcMoneyTransfer  } from 'react-icons/fc';
import styled from 'styled-components';
import { DarkThemeColor ,ThemeBorderColor} from '../../utils';
import Card from './Card';

function WalletCard(props) {
    return (
        <Card clickCardHandler={props.clickCardHandler} title="موجودی کیف پول" icon={FcMoneyTransfer }>
            <Score>{props.CreditAmount.toLocaleString()}</Score><Currency>ريال</Currency>
        </Card>
    );
}
const Score = styled.span`
    color: ${DarkThemeColor};
    width: 120px;
    margin:10px 20px;
    display: inline-block;
    border-radius: 1rem;
    padding: 0.7rem;
    border: 2px solid ${ThemeBorderColor};
    font-size: x-large;
`;
const Currency = styled.span`
    font-size: small;
`;
export default WalletCard;